import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SubscriptionStatus } from '../../models';
import { SubscriptionService } from '../../services/supabase/subscription.service';

@Component({
  selector: 'app-subscription-banner',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './subscription-banner.component.html',
  styleUrl: './subscription-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionBannerComponent {
  private readonly subs = inject(SubscriptionService);

  readonly state = computed<SubscriptionStatus | null>(() => {
    const s = this.subs.subscription();
    if (!s) return null;
    if (s.status === 'active') return null;
    return s.status;
  });

  manage(): void {
    this.subs.openManageUrl();
  }
}
